import { FetchAuth } from "../utils/FetchAuthUtil";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class HelpService {
    public static createHelp = async (help: { eng: string, fr: string, ar: string }, _id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(endpoint + `/websettings/update/${_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "helpAndSupport": help
                }),
            });

            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    }
} 